import { LegalPage } from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "Who you are dealing with",
    blocks: [
      {
        text: "Niagara Callback, a sole proprietorship owned by Carlo Vescio, at 8605 Glavcic Drive, Niagara Falls, Ontario, L2H 0B1. Ontario BIN 1001765861.",
      },
    ],
  },
  {
    heading: "What the service is",
    blocks: [
      {
        text: "When a call to your business line goes unanswered, your carrier passes it to a second phone number we set up. That number sends the caller a text from your business, usually within a minute, and alerts you at the same time. You reply from an app on your phone.",
      },
      { text: "Your own business number does not change." },
    ],
  },
  {
    heading: "What you pay",
    blocks: [
      { text: "Setup: $1,000 CAD + HST, one time" },
      { text: "Monthly service: $650 CAD + HST" },
      { text: "No contract. Cancel any time with 30 days' written notice." },
      {
        text: "Setup is invoiced when you sign. Monthly billing starts on your go-live date, not the day you sign, because carrier approval takes about a week and we do not bill for a service that is not running.",
      },
      {
        text: "Invoices are payable within 14 days. Monthly fees are collected by pre-authorized debit.",
      },
    ],
  },
  {
    heading: "What setup includes",
    blocks: [
      {
        text: "A dedicated business texting number, carrier registration, call-forwarding configuration, the automated text-back and alert workflows, an exclusion list for family, staff and suppliers, testing, and about 45 minutes at your shop going live together.",
      },
    ],
  },
  {
    heading: "What you are responsible for",
    blocks: [
      {
        items: [
          "Giving us the numbers that must never be texted, such as family, staff and suppliers",
          "Setting up call forwarding on your line, with our help",
          "Responding to customers who reply",
          "Using the service lawfully, and not for marketing or promotional messages",
          "Telling us promptly if something stops working",
        ],
      },
    ],
  },
  {
    heading: "Honest limits",
    blocks: [
      {
        text: "Landlines and hidden numbers cannot receive text messages. Those calls go to voicemail exactly as they do today. Nobody can change this.",
      },
      {
        text: "Message delivery is not guaranteed. Carriers filter, networks fail, phones are off. We do everything reasonable, but we do not control the phone network and cannot promise every message arrives.",
      },
      {
        text: "Go-live takes about a week from signing, mostly waiting on carrier approval. We cannot speed that up.",
      },
      {
        text: "This does not generate new calls. It recovers calls you are already missing. That is the whole claim.",
      },
    ],
  },
  {
    heading: "Our commitments",
    blocks: [
      {
        text: "We monitor your system, fix problems, and send you a monthly summary of calls recovered. For the first two weeks after go-live we check it daily. If something breaks, text 905-351-7489 and you will reach Carlo, not a call centre.",
      },
    ],
  },
  {
    heading: "Your data",
    blocks: [
      {
        text: "Your contacts and conversation history are yours. If you leave, we will provide them in a standard format at no charge.",
        link: { href: "/privacy", text: "See the Privacy Policy." },
      },
    ],
  },
  {
    heading: "Cancelling",
    blocks: [
      {
        text: "Either of us may end the arrangement with 30 days' written notice. There is no cancellation fee and no refund of the setup fee, which covers work already done.",
      },
    ],
  },
  {
    heading: "Liability",
    blocks: [
      {
        text: "We will do this job properly. But our total liability for any claim is limited to the fees you paid us in the three months before the claim. We are not liable for lost business, lost profit, or indirect losses. Nothing here limits liability that cannot lawfully be limited.",
      },
    ],
  },
  {
    heading: "Governing law",
    blocks: [
      {
        text: "The laws of the Province of Ontario and the laws of Canada applicable in it. The courts of Ontario have jurisdiction.",
      },
    ],
  },
  {
    heading: "Contact",
    blocks: [
      { text: "Carlo Vescio · Niagara Callback" },
      { text: "8605 Glavcic Drive, Niagara Falls, Ontario, L2H 0B1" },
      { text: "905-351-7489 · carlo@niagaracallback.ca" },
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" updated="3 October 2026" sections={SECTIONS} testId="terms-page" />
  );
}
